import detail from './product/detail';
import quickViewPdp from './product/quickViewPdp';
import turnToPdp from 'turnToCustom/turnToPdp';
import pagedesignerCustom from './search/pagedesignerCustom';
import sizeGuide from './product/sizeGuide';
import headerhelper from './helpers/headerHelper';
var processInclude = require('base/util');

// eslint-disable-next-line no-undef
$(document).ready(function () {
    processInclude(headerhelper);
    processInclude(detail);
    processInclude(quickViewPdp);
    processInclude(turnToPdp);
    processInclude(pagedesignerCustom);
    processInclude(sizeGuide);
});
